// 创建一个pdf.js文件，放在你想放的位置

// 页面导出为pdf格式
import html2Canvas from 'html2canvas'
import { jsPDF as JsPDF } from 'jspdf'
// 画布添加水印
function drawWaterMark(ctx, imgWidth, imgHeight, wmConfig) {
  const fontSize = 16
  ctx.font = `${fontSize}px ${wmConfig.font}`
  ctx.lineWidth = 1
  ctx.fillStyle = 'rgba(0,0,0,0.2)' // 根据页面的背景色来设置水印颜色
  ctx.textAlign = 'left'
  ctx.textBaseline = 'middle'

  // 文字坐标
  const maxPx = Math.max(imgWidth, imgHeight)
  const stepPx = 200
  const arrayX = [0] // 初始水印位置 canvas坐标 0 0 点
  while (arrayX[arrayX.length - 1] < maxPx / 2) {
    arrayX.push(arrayX[arrayX.length - 1] + stepPx)
  }
  arrayX.push(
    ...arrayX.slice(1, arrayX.length).map((el) => {
      return -el
    })
  )
  const lineHeightFactor = 1.5 // 行间距的倍数
  for (let i = 0; i < arrayX.length; i++) {
    for (let j = 0; j < arrayX.length; j++) {
      ctx.save()
      ctx.translate(imgWidth / 2, imgHeight / 2) // 画布旋转原点 移到 图片中心
      ctx.rotate(-Math.PI / 5)
      if (wmConfig.textArray.length > 3) {
        wmConfig.textArray = wmConfig.textArray.slice(0, 3)
      }
      wmConfig.textArray.forEach((el, index) => {
        const offsetY = fontSize * index * lineHeightFactor + 15
        ctx.fillText(el, arrayX[i], arrayX[j] + offsetY)
      })
      ctx.restore()
    }
  }
}
// 给base64图片添加水印
function base64AddWaterMaker(base64Img, wmConfig) {
  if (wmConfig.textArray.length === 0) {
    console.error('****没有水印内容*****')
    return base64Img
  }
  return new Promise((resolve, reject) => {
    const canvas = document.createElement('canvas')
    const ctx = canvas.getContext('2d')
    const img = new Image()
    let resultBase64 = null
    img.onload = () => {
      canvas.width = img.width
      canvas.height = img.height
      // canvas绘制图片，0 0  为左上角坐标原点
      ctx.drawImage(img, 0, 0)
      // 写入水印
      drawWaterMark(ctx, img.width, img.height, wmConfig)
      resultBase64 = canvas.toDataURL('image/png')
      if (!resultBase64) {
        reject()
      } else {
        resolve(resultBase64)
      }
    }
    img.src = base64Img
  })
}
/**
 * title：导出文件的名称
 * id: 页面需要导出div区域的id
 * type: 导出的文件类型-分页/不分页
 */
const htmlToPdf = {
  getPdf(title, id, type, watermark) {
    html2Canvas(document.querySelector(id), {
      allowTaint: false,
      taintTest: false,
      logging: false,
      useCORS: true,
      dpi: window.devicePixelRatio * 4, // 将分辨率提高到特定的DPI
      scale: 1, // 按比例增加分辨率
      onclone: (document) => {
        // 屏蔽id为analyse-hidden的元素，不出现在pdf中
        // document.getElementById('analyse-hidden').style.display = 'none'
      }
    }).then(async (canvas) => {
      if (type === '分页') {
        const pdf = new JsPDF('p', 'mm', 'a4') // A4纸，纵向
        const ctx = canvas.getContext('2d')
        const a4w = 190
        const a4h = 272 // A4大小，210mm x 297mm，四边各保留10mm的边距，显示区域190x277
        const imgHeight = Math.floor((a4h * canvas.width) / a4w) // 按A4显示比例换算一页图像的像素高度
        let renderedHeight = 0

        while (renderedHeight < canvas.height) {
          const page = document.createElement('canvas')
          page.width = canvas.width
          page.height = Math.min(imgHeight, canvas.height - renderedHeight) // 可能内容不足一页

          // 用getImageData剪裁指定区域，并画到前面创建的canvas对象中
          page
            .getContext('2d')
            .putImageData(
              ctx.getImageData(
                0,
                renderedHeight,
                canvas.width,
                Math.min(imgHeight, canvas.height - renderedHeight)
              ),
              0,
              0
            )
          pdf.addImage(
            page.toDataURL('image/jpeg', 1.0),
            'JPEG',
            10,
            10,
            a4w,
            Math.min(a4h, (a4w * page.height) / page.width)
          ) // 添加图像到页面，保留10mm边距

          renderedHeight += imgHeight
          if (renderedHeight < canvas.height) {
            pdf.addPage() // 如果后面还有内容，添加一个空页
          }
          // delete page;
        }
        pdf.save(title + '.pdf')
      } else {
        /** 不分页 */
        const contentWidth = canvas.width
        const contentHeight = canvas.height
        const imgUrl = canvas.toDataURL('image/jpeg', 1.0)
        // 获取用户信息，添加到水印内容中

        const wmConfig = {
          font: 'microsoft yahei', // 字体
          textArray: [watermark] // 水印文本内容，允许数组最大长度3 即：3行水印
        }
        const resultBase64 = await base64AddWaterMaker(imgUrl, wmConfig)
        // 将添加了水印的截图赋值给pageData用于PDF.addImage
        const pageData = resultBase64
        const pdfWidth = ((contentWidth + 10) / 2) * 0.5
        const pdfHeight = ((contentHeight + 200) / 2) * 0.75
        const imgWidth = pdfWidth
        const imgHeight = (contentHeight / 2) * 0.5 // 内容图片这里不需要留白的距离
        // 如果生成的图片宽度比高度大，赋值为高度就会裁剪掉图片，导致文字显示不全，所以必须赋值为pdfHeight；当图片高度大于宽度时pdf的高度可以使用图片的高度，这里给留白50
        const PDF = new JsPDF('p', 'mm', [pdfWidth + 20, imgWidth > imgHeight ? pdfHeight : imgHeight + 50])
        // x坐标偏移10
        PDF.addImage(pageData, 'jpeg', 10, 0, imgWidth, imgHeight)
        PDF.save(title + '.pdf')
      }
    })
  }
}

export default htmlToPdf



// WEBPACK FOOTER //
// ./src/utils/htmlToPdf.js